import { el } from '../../core/dom.js';

export function cxBtn(label, opts = {}) {
  const className = opts.className || 'cx-btn';
  return el('button', {
    type: opts.type || 'button',
    class: className,
    disabled: opts.disabled ? true : null,
    'aria-pressed': opts.pressed == null ? null : (opts.pressed ? 'true' : 'false'),
    onClick: opts.onClick,
  }, label, opts.arrow ? el('span', { class: 'cx-arw', 'aria-hidden': 'true' }, '→') : null);
}

export function sectionNote(title, message, action) {
  return el('div', { class: 'cx-empty', role: 'status' },
    title ? el('p', { class: 'cx-kicker' }, title) : null,
    message ? el('p', { class: 'cx-copy' }, message) : null,
    action || null);
}

export function sectionError(title, message, onRetry) {
  return el('div', { class: 'cx-empty', role: 'alert' },
    el('p', { class: 'cx-kicker' }, 'Error'),
    el('p', { class: 'cx-empty-title' }, title),
    el('p', { class: 'cx-copy' }, message || 'Something went wrong.'),
    onRetry ? cxBtn('Try again', { onClick: onRetry }) : null);
}
